import React from 'react';
import Description from './smallerComponent/Description';
import Button from './smallerComponent/Button';
import Image from './smallerComponent/Image';
import bodyImage from '../images/illustration-working.svg';


export default function First(){
  return(
      <div className="fbody">
         <div className="left">
           <Description header="More than just shorter links" paragraph="Build your brand's recognition and get detailed insights on how your links are performing."/>
           <Button className="getStarted" value="Get started" type="submit"/>
         </div>
         <div className="right">
        <Image className="bodyImage" src={bodyImage} alt="bodyImage"/>
         </div>
      </div>
  )
}